import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { LocaleService } from '../services/locale.service'
import { SharedDataService } from './shared-data.service';
import { environment } from 'src/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  private headers: HttpHeaders;

  constructor(private http: HttpClient,
    private localeService: LocaleService,
    private sharedDataService: SharedDataService
  ) { }

  private getHeaders() {
    this.headers = new HttpHeaders({
      'Accept-Language': this.localeService.getHeaderLocale()
    });
    const token = this.sharedDataService.getToken()
    if(token) {
      this.headers = this.headers.append('Authorization', 'Bearer ' + token)
    }
  }

  private getUrl(urlEndpoint: string): string {
    if(!environment.production && !_.isEmpty(this.sharedDataService.apiUrl)) return this.sharedDataService.apiUrl + urlEndpoint;
    return environment.API_URL + urlEndpoint
  }

  parseUrlQueryParams(url: string, options: Record<string, unknown>): string {
    const urlQueryParams = options || {};
    Object.entries(urlQueryParams).forEach(([key, value]) => {
      if(typeof value === 'string') value = encodeURIComponent(value);
      url += (url.indexOf('?') > 0 ? '&' : '?') + key + '=' + value;
    });

    return url;
  }

  async get(urlEndpoint: string, criteria?: any): Promise<any> {
    this.getHeaders()
    let url = this.getUrl(urlEndpoint)

    if(criteria) {
      url = this.parseUrlQueryParams(url, criteria);
    }

    return await firstValueFrom(this.http.get(url, {headers: this.headers})).catch((err) => {
      throw typeof err === 'function' ? err() : err;
    });
  }

  getObservable(urlEndpoint: string, criteria?: any, httpOptions = {}): Observable<any>{
    this.getHeaders();
    let url = this.getUrl(urlEndpoint);

    if(!_.isEmpty(criteria)) {
      url = this.parseUrlQueryParams(url, criteria);
    }

    return this.http.get(url, {headers: this.headers, ...httpOptions});
  }

  postObservable(urlEndpoint:string, body, options: any): Observable<any> {
    this.getHeaders()
    const url = this.getUrl(urlEndpoint)
    return this.http.post(url, body, { headers: this.headers, ...options });
  }

  async put(urlEndpoint:string, body): Promise<any> {
    this.getHeaders()
    const url = this.getUrl(urlEndpoint)
    return await firstValueFrom(this.http.put(url, body, {headers: this.headers})).catch((err) => {
      throw typeof err === 'function' ? err() : err;
    });
  }

  async post(urlEndpoint:string, body): Promise<any> {
    this.getHeaders()
    const url = this.getUrl(urlEndpoint)
    return await firstValueFrom(this.http.post(url, body, {headers: this.headers})).catch((err) => {
      throw typeof err === 'function' ? err() : err;
    });
  }

  delete(urlEndpoint: string): Promise<any> {
    this.getHeaders()
    const url = this.getUrl(urlEndpoint);
    return firstValueFrom(this.http.delete(url, {headers: this.headers})).catch((err) => {
      throw typeof err === 'function' ? err() : err;
    });
  }

}
